import React from 'react';
import styled from 'styled-components';

import { TAppElkMessage } from 'TProtocol/prototypes/events/messages';
import AttendeeCircle from './AttendeeCircle';

const dateFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
const timeFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

interface Props {
  message: TAppElkMessage;
  isLast: boolean;
}

const AttendeeHostReply = ({ message, isLast }: Props) => {
  return <RowContainer>
    <LineContainer>
      <Line>&nbsp;</Line>
    </LineContainer>
    <MessageContainer>
      <AttendeeCircle attendee={message.senderProfile}/>
      <div>
        {message.message}
        <SentTime>
          sent on {dateFormat.format(message.sentTime.toNumber())} at {timeFormat.format(message.sentTime.toNumber())}
        </SentTime>
      </div>
    </MessageContainer>
  </RowContainer>
};

const RowContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const LineContainer = styled.div`
  min-width: 35px;
  flex-grow: 0;
`;

const Line = styled.div`
  border: 1px solid var(--shine-text-color);
  border-top: 0;
  border-right: 0;
  border-bottom-left-radius: 6px;
  height: 50%;
  margin-left: 20px;
`

const MessageContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding-left: 5px;
`;

const SentTime = styled.div`
  font-size: 14px;
  opacity: .5;
`;

export default AttendeeHostReply;
